import React, {useEffect} from "react";
import Dashboard from "../Dashboard";
import {setHelpContext} from "../../prodect/HelpManager";

export default function ProjectDashboard(props) {
    const main_proj_id = props.customerAndProject?.main_proj_id
    useEffect(()=> {
        setHelpContext('dashboard-main')
    })
    return <section className="content content-project content-dashboard">
        <Dashboard
            projectId={main_proj_id}
            editTableLinkSettings={''}
            mainPrj={true}
        />
    </section>
}